import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  ButtonsModule,
  CardModule,
  DropdownModule,
  InputModule,
  LoadingService,
  RadioButtonModule,
} from 'axis-components';
import { AxisValidatorModule } from 'axis-components/customValidators';
import { Logger } from '../../../_core/logger.service';
import { PdfService } from '../../../_services/pdf/pdf.service';
import { NondigitalService } from '../../../_services/pip/nondigital.service';
import { RequestService } from '../../../_services/request/request.service';
import { UserService } from '../../../_services/user.service';
import { AnalyticsService } from '../../../_shared/analytics/analytics.service';
import {
  FormType,
  RequestProgressStep,
  PDFGenerationStatus,
} from '../../../config/constants';
import { NonDigitalContent } from '../../pip/pip-thankyou/pip-thankyou.constants';
import { finalize } from 'rxjs';
import { PipBaseStateComponent } from '../../../state-disclosures/pip/pip-base-state.component';

@Component({
  selector: 'app-pip-non-digital-elections',
  templateUrl: './pip-non-digital-elections.component.html',
  styleUrls: ['./pip-non-digital-elections.component.scss'],
  standalone: true,
  imports: [
    ButtonsModule,
    InputModule,
    CardModule,
    CommonModule,
    DropdownModule,
    FormsModule,
    RadioButtonModule,
    ReactiveFormsModule,
    AxisValidatorModule,
    RouterModule,
  ],
})
export class PipNonDigitalElectionsComponent {
  public pipNonDigi: FormGroup;
  dropdownErrorBlurred = true;
  accountDetails: any = null;
  flow: string = '';
  constructor(
    private readonly nondigitalService: NondigitalService,
    private router: Router,
    private fb: FormBuilder,
    private userService: UserService,
    private requestService: RequestService,
    private analyticsService: AnalyticsService,
    private pdfService: PdfService,
    public route: ActivatedRoute,
    private loadingService: LoadingService,
  ) {}
  nonDigital: any;
  formData: any = {};
  selectedOption = '';
  userRole;
  requestKey = '';
  content = NonDigitalContent.WithPip;
  @Output() optionSelected = new EventEmitter<string>();

  public stateList = [
    { name: 'Alabama', id: 'AL' },
    { name: 'Alaska', id: 'AK' },
    { name: 'Arizona', id: 'AZ' },
    { name: 'Arkansas', id: 'AR' },
    { name: 'California', id: 'CA' },
    { name: 'Colorado', id: 'CO' },
    { name: 'Connecticut', id: 'CT' },
    { name: 'Delaware', id: 'DE' },
    { name: 'Florida', id: 'FL' },
    { name: 'Georgia', id: 'GA' },
    { name: 'Hawaii', id: 'HI' },
    { name: 'Idaho', id: 'ID' },
    { name: 'Illinois', id: 'IL' },
    { name: 'Indiana', id: 'IN' },
    { name: 'Iowa', id: 'IA' },
    { name: 'Kansas', id: 'KS' },
    { name: 'Kentucky', id: 'KY' },
    { name: 'Louisiana', id: 'LA' },
    { name: 'Maine', id: 'ME' },
    { name: 'Maryland', id: 'MD' },
    { name: 'Massachusetts', id: 'MA' },
    { name: 'Michigan', id: 'MI' },
    { name: 'Minnesota', id: 'MN' },
    { name: 'Mississippi', id: 'MS' },
    { name: 'Missouri', id: 'MO' },
    { name: 'Montana', id: 'MT' },
    { name: 'Nebraska', id: 'NE' },
    { name: 'Nevada', id: 'NV' },
    { name: 'New Hampshire', id: 'NH' },
    { name: 'New Jersey', id: 'NJ' },
    { name: 'New Mexico', id: 'NM' },
    { name: 'New York', id: 'NY' },
    { name: 'North Carolina', id: 'NC' },
    { name: 'North Dakota', id: 'ND' },
    { name: 'Ohio', id: 'OH' },
    { name: 'Oklahoma', id: 'OK' },
    { name: 'Oregon', id: 'OR' },
    { name: 'Pennsylvania', id: 'PA' },
    { name: 'Rhode Island', id: 'RI' },
    { name: 'South Carolina', id: 'SC' },
    { name: 'South Dakota', id: 'SD' },
    { name: 'Tennessee', id: 'TN' },
    { name: 'Texas', id: 'TX' },
    { name: 'Utah', id: 'UT' },
    { name: 'Vermont', id: 'VT' },
    { name: 'Virginia', id: 'VA' },
    { name: 'Washington', id: 'WA' },
    { name: 'West Virginia', id: 'WV' },
    { name: 'Wisconsin', id: 'WI' },
    { name: 'Wyoming', id: 'WY' },
  ];

  public mySettings110: any = {
    reg_exp: '^[-\\d]+$',
  };

  ngOnInit() {
    this.getAccountDetails();
    this.userRole = this.userService.role;
    this.requestKey = this.requestService.getRequestKey() || '';

    this.pipNonDigi = this.fb.group({
      piprejectDigiSelect: ['', Validators.required],
      piprejInsuredName: [
        this.accountDetails.insuredName || '',
        Validators.required,
      ],
      piprejInsuredMail: [
        this.accountDetails.insuredEmail || '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z0-9.\\-]{2,63}$',
          ),
        ],
      ],
      piprejInsuredAddress: [
        this.accountDetails.address || '',
        Validators.required,
      ],
      piprejInsuredCity: [this.accountDetails.city || '', Validators.required],
      piprejInsuredState: [
        this.accountDetails.state || '',
        Validators.required,
      ],
      piprejInsuredZipCode: [
        this.accountDetails.zipCode || '',
        [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')],
      ],
    });
    this.nondigitalService.getNonDigitalData().subscribe((data) => {
      this.nonDigital = data;
    });
    this.goTop();

    this.route.queryParams.subscribe((params) => {
      if (params['flow']) {
        setTimeout(() => {
          this.flow = params['flow'];
        }, 100);
      }
    });
  }
  goTop(): void {
    // reset the page when changing route
    window.scrollTo(0, 0);
  }
  getAccountDetails(): void {
    if (
      this.requestService.request &&
      this.requestService.request.requestDetails &&
      this.requestService.request.requestDetails.accountDetail
    ) {
      this.accountDetails =
        this.requestService.request.requestDetails.accountDetail;
    }
  }
  updateRequestDetailsWithFormData() {
    const stateValue = this.pipNonDigi.value.piprejInsuredState;
    const stateCode =
      typeof stateValue === 'object' && stateValue !== null
        ? stateValue.id // Extract the state code if it's an object
        : stateValue;
    // Find the matching state object in stateList using the state code
    const stateObject = this.stateList.find((state) => state.id === stateCode);
    const stateName = stateObject ? stateObject.name : stateCode;

    const zipCode = this.pipNonDigi.value.piprejInsuredZipCode;
    // Get account detail values from the form
    const accountDetails = {
      accountDetail: {
        insuredName: this.pipNonDigi.value.piprejInsuredName,
        insuredEmail: this.pipNonDigi.value.piprejInsuredMail,
        address: this.pipNonDigi.value.piprejInsuredAddress,
        city: this.pipNonDigi.value.piprejInsuredCity,
        state: stateName,
        zipcode: zipCode,
      },
    };
    // Update request details with new account values
    this.requestService.updateRequestDetails(accountDetails);
  }
  onOptionChange(value: string): void {
    this.selectedOption = value;
    this.pipNonDigi.get('piprejectDigiSelect')?.setValue(value);
    this.pipNonDigi.get('piprejectDigiSelect').markAsTouched();
    this.optionSelected.emit(value);
  }
  onContinue(): void {
    this.pipNonDigi.get('piprejectDigiSelect').markAsTouched();
    if (this.pipNonDigi.get('piprejectDigiSelect')?.invalid) {
      return;
    }
    this.updateRequestDetailsWithFormData();
    if (this.selectedOption === 'mail') {
      [
        'piprejInsuredName',
        'piprejInsuredMail',
        'piprejInsuredAddress',
        'piprejInsuredCity',
        'piprejInsuredState',
        'piprejInsuredZipCode',
      ].forEach((key) => {
        this.pipNonDigi.get(key)?.markAsTouched();
      });
      if (this.pipNonDigi.invalid) {
        return;
      }
    }
    if (this.selectedOption === 'digital') {
      this.router.navigate(['/insured/pip-consent'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      let step = RequestProgressStep.NON_DIGITAL_ELECTION_DOWNLOAD;
      let data = {};
      let emailType = 'nonDigitalDownload';
      if (this.selectedOption === 'download') {
        step = RequestProgressStep.NON_DIGITAL_ELECTION_DOWNLOAD;
        emailType = 'nonDigitalDownload';
      } else if (this.selectedOption === 'mail') {
        step = RequestProgressStep.NON_DIGITAL_ELECTION_SHIP_FORMS;
        emailType = 'nonDigitalShip';
        data = {
          mailingAddress: {
            insuredName: this.pipNonDigi.get('piprejInsuredName')?.value,
            insuredEmail: this.pipNonDigi.get('piprejInsuredMail')?.value,
            streetAddress: this.pipNonDigi.get('piprejInsuredAddress')?.value,
            city: this.pipNonDigi.get('piprejInsuredCity')?.value,
            state: this.pipNonDigi.get('piprejInsuredState')?.value,
            zipCode: this.pipNonDigi.get('piprejInsuredZipCode')?.value,
          },
        };
      }

      const submitWithCompletionGuard = (wasAlreadyCompleted: boolean) => {
        const isPipCompleted = this.requestService.isFormTypeAlreadyCompleted(
          FormType.PIP,
        );

        // If PIP is already completed, do not continue with consent routing.
        if (isPipCompleted) {
          return;
        }
        PipBaseStateComponent.resetLoadingState();
        this.loadingService.start('Loading');
        this.requestService
          .updateRequestProgress(FormType.PIP, step, data)
          .then(() => {
            const targetRoute =
              this.requestService.requestFormTypeList.length === 1 &&
              this.requestService.requestFormTypeList[0] === FormType.PIP
                ? '/thank-you'
                : '/insured/pip-thankyou';

            // Only emit completion when this submit newly completes the PIP form.
            if (!wasAlreadyCompleted) {
              this.analyticsService.emitFormCompleteOnce(
                FormType.PIP,
                'DigiSign:pip:thankYou',
                targetRoute,
              );
            }

            this.pdfService.pipPdfGenerationStatus =
              PDFGenerationStatus.RequestSent;
            this.pdfService
              .generatePIPPdfAndSendEmail(false, emailType)
              .pipe(
                finalize(() => {
                  this.loadingService.stop();

                  // Navigate to thank you page after step update is complete
                  if (!this.userService.role.match('broker')) {
                    if (targetRoute === '/thank-you') {
                      this.router.navigate(['/thank-you'], {
                        queryParamsHandling: 'preserve',
                      });
                    } else {
                      this.router.navigate(['/insured/pip-thankyou'], {
                        queryParamsHandling: 'preserve',
                      });
                    }
                  }
                }),
              )
              .subscribe(
                (res) => {
                  this.pdfService.pipPdfGenerationStatus =
                    PDFGenerationStatus.ResponseReceived;

                  if (!this.userService.role.match('broker')) {
                    this.analyticsService.logNonDigitalElectionsEvent(
                      FormType.PIP,
                      this.selectedOption,
                    );
                  }
                },
                (err) => {
                  this.pdfService.pipPdfGenerationStatus =
                    PDFGenerationStatus.Error;
                },
              );
          });
      };

      // Refresh from DB before submit to guard duplicate completes across sessions/browsers.
      this.requestService.refreshRequestData(false).subscribe({
        next: () => {
          submitWithCompletionGuard(
            this.requestService.isFormTypeAlreadyCompleted(FormType.PIP),
          );
        },
        error: () => {
          submitWithCompletionGuard(
            this.requestService.isFormTypeAlreadyCompleted(FormType.PIP),
          );
        },
      });
    }
  }

  backConsentPage(): void {
    this.router.navigate(['/insured/pip-consent'], {
      queryParamsHandling: 'preserve',
    });
  }
}
